import React, { useState } from "react";
import { useUI } from "../../context/UIContext";
import { serverShutdown } from "../../api";

export default function ShutdownModal({ id, onConfirm }) {
  const { toast, closeModal } = useUI();
  const [name, setName] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    if (name !== id) return toast(`Gõ đúng tên: ${id}`, "err");
    if (!pw) return toast("Nhập mật khẩu", "err");
    if (busy) return;
    setBusy(true);
    try {
      const { ok, data } = await serverShutdown(id, {
        user: "Administrator",
        password: pw,
      });
      if (!ok) {
        setBusy(false);
        return toast(data.message || "Không gửi được lệnh shutdown", "err");
      }
      closeModal();
      onConfirm(id);
      toast(`${id} đang tắt máy...`, "err");
    } catch {
      setBusy(false);
      toast("Không kết nối được BackendNode", "err");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <div style={{
        background: "var(--red-soft)",
        border: "1px solid var(--red)",
        borderRadius: "10px",
        padding: "12px 14px",
        color: "var(--red)",
        fontSize: "13px",
        lineHeight: "1.5",
      }}>
        ⛔ NGUY HIỂM: Tắt máy chủ <strong>{id}</strong> sẽ ngừng TOÀN BỘ dịch vụ và ngắt kết nối hoàn toàn.
      </div>
      
      <div className="field-lbl">
        Gõ tên server để xác nhận:{" "}
        <strong style={{ color: "var(--red)" }}>{id}</strong>
      </div>
      <input
        className="field-inp"
        type="text"
        value={name}
        placeholder={id}
        onChange={(e) => setName(e.target.value)}
      />
      
      <div className="field-lbl">Mật khẩu admin</div>
      <input
        className="field-inp"
        type="password"
        value={pw}
        placeholder="••••••••"
        onChange={(e) => setPw(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && confirm()}
      />
      
      <div className="modal-footer" style={{ marginTop: "15px" }}>
        <button className="mbtn mbtn-cancel" onClick={closeModal}>
          Huỷ
        </button>
        <button className="mbtn mbtn-danger" onClick={confirm} disabled={busy}>
          {busy ? "…" : "⏻ Tắt máy"}
        </button>
      </div>
    </div>
  );
}
